import { render, staticRenderFns } from "./VolumeRulesManagementAnother.vue?vue&type=template&id=76cb7582&scoped=true"
import script from "./VolumeRulesManagementAnother.vue?vue&type=script&lang=js"
export * from "./VolumeRulesManagementAnother.vue?vue&type=script&lang=js"
import style0 from "./VolumeRulesManagementAnother.vue?vue&type=style&index=0&id=76cb7582&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb7582",
  null
  
)

export default component.exports